import { render, staticRenderFns } from "./AllocateDeposit.vue?vue&type=template&id=44c092b0&"
import script from "./AllocateDeposit.vue?vue&type=script&lang=js&"
export * from "./AllocateDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports